import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { ShowcaseItemAdminDto } from '@/backend/market'
import { ShowcaseItemRequestEntity } from '../../domain/entities/ShowcaseItemRequestEntity'

export class ItemShowcaseModel extends ShowcaseItemRequestEntity {
  constructor(dataDto: ShowcaseItemAdminDto) {
    super()
    mapEntityProperties<ShowcaseItemRequestEntity>(this, {
      name: dataDto.itemName,
      id: dataDto.itemId
    })
  }
}
